import { render, staticRenderFns } from "./InstructionsFrame.vue?vue&type=template&id=e3b9d638&scoped=true"
import script from "./InstructionsFrame.vue?vue&type=script&lang=js"
export * from "./InstructionsFrame.vue?vue&type=script&lang=js"
import style0 from "./InstructionsFrame.vue?vue&type=style&index=0&id=e3b9d638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b9d638",
  null
  
)

export default component.exports